module.exports = __webpack_public_path__ + "img/av287.d157bc17.png";